import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { IApiRequest, IApiresponse } from "src/app/_models";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import { IEssentialPackDetails,IEssentialPackDetailsRequest,BandPlanResponse} 
from "src/app/_models/essential-pack/essential-pack";
import { map } from "rxjs/operators";
import { RSAHelper } from 'src/app/_helpers/RSAHelper';

@Injectable({
  providedIn: "root",
})
export class EssentialPackService {

  constructor(
    private http: HttpClient,
    private claimsHeaderService: ClaimsHeaderService
  ) { }

  GetEssentialPackDetails( 
    requestInfo: IApiRequest<IEssentialPackDetailsRequest> ): Observable<IApiresponse<IEssentialPackDetails>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IEssentialPackDetails>>(
            `${environment.catalogApiUrl}GetEssentialPackDetails`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
  }

  GetBandPlanList(bandId: number): Observable<IApiresponse<BandPlanResponse[]>> {
    let params = new HttpParams();
    params = params.append("bandId", bandId.toString());
    return this.http.get<IApiresponse<BandPlanResponse[]>>(`${environment.catalogApiUrl}GetBandPlanList`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}

GetBandPlanById(bandPlanId: number): Observable<IApiresponse<BandPlanResponse>> {
  let params = new HttpParams();
  params = params.append("bandPlanId", bandPlanId.toString());
  return this.http.get<IApiresponse<BandPlanResponse>>(`${environment.catalogApiUrl}GetBandPlanById`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}

EncryptParameters(encryptValue) {
  let rsaHelper = new RSAHelper();
  let encrypt = rsaHelper.Encrypt(encryptValue);
  return encrypt;
}
DecryptParameters(encryptedParam): string {
  let rsaHelper = new RSAHelper();
  let decrypt = rsaHelper.Decrypt(encryptedParam);
  return decrypt;
}


}
